import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@features/auth/core/domain/login/auth-version-2.service';
import { duongDanCongSvMoi } from '@core/guards/redirect-cong-sv-moi.guard';

@Component({
  standalone: true,
  selector: 'app-auth-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css'],
})
export class LogoutComponent implements OnInit {
  authService = inject(AuthService);
  router = inject(Router);
  showLoading: boolean = false;
  constructor() {}

  /**
   * Sau khi đăng xuất thì về trang đăng nhập của **cổng sinh viên mới**, không
   * phải `/login` nội bộ của app này.
   *
   * ⚠ S03: cổng mới đã nắm tên miền chính và là nơi duy nhất còn hỏi đăng nhập
   * (luồng SSO OAuth2). Đưa về `/login` của app này là bày ra một trang đăng nhập
   * thứ hai mà luồng mới không dùng tới.
   *
   * Địa chỉ khác nhau ở cả 4 môi trường — dưới local là `http://localhost:4001`.
   * Thiếu khai thì rơi về `/login` nội bộ như cũ, không gãy.
   */
  private veTrangDangNhap(): void {
    const dich = duongDanCongSvMoi('/login');
    if (dich) {
      window.location.href = dich;
      return;
    }
    void this.router.navigate(['login']);
  }

  ngOnInit() {
    this.showLoading = true;
    this.authService.logout().subscribe({
      next: (value) => {
        console.log(value);
        this.veTrangDangNhap();
        this.showLoading = false;
      },
      error: (err) => {
        this.veTrangDangNhap();
        this.showLoading = false;
        console.error(`Error when logout: ${err.message}`);
      },
    });
  }
}
